import React from 'react';

import { TabsProps } from 'views/RollingOffers/types';

import { SubOffersList } from '../../components/SubOfferCard';

const ConfigurationTab: React.FC<TabsProps> = ({
  formikProps,
  rollingOfferId,
  productsSequence,
  setProductsSequence,
  setBarPointsValidity
}) => {
  return (
    <SubOffersList
      formikProps={formikProps}
      rollingOfferId={rollingOfferId}
      productsSequence={productsSequence}
      setProductsSequence={setProductsSequence}
      setBarPointsValidity={setBarPointsValidity}
    />
  );
};

export default ConfigurationTab;
